export default __webpack_public_path__ + "static/media/logo-glamstar.fb85656e.webp";